export default __webpack_public_path__ + "static/media/CHF1P.54bc22a8.png";